import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

// Session token storage key
const SESSION_TOKEN_KEY = 'orq_session_token';

// Create axios instance with default config
const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include session token in Authorization header
api.interceptors.request.use(
  (config) => {
    const sessionToken = localStorage.getItem(SESSION_TOKEN_KEY);
    if (sessionToken) {
      config.headers.Authorization = `Bearer ${sessionToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // If 401 Unauthorized, clear session and redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem(SESSION_TOKEN_KEY);
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Helper function to save session token
export const saveSessionToken = (token) => {
  if (token) {
    localStorage.setItem(SESSION_TOKEN_KEY, token);
  }
};

// Helper function to clear session token
export const clearSessionToken = () => {
  localStorage.removeItem(SESSION_TOKEN_KEY);
};

// Helper function to get session token
export const getSessionToken = () => {
  return localStorage.getItem(SESSION_TOKEN_KEY);
};

export default api;
export { API };
